/**
 * Every brand-dependent value lives here.
 *
 * The defaults follow the Taco Bell system - one purple, used as an accent on
 * white rather than as a flood - but nothing in the components hard-codes a
 * colour or a logo, so another TacoBots application, or a rebrand, only has to
 * change these environment variables (specification section 38).
 */


export interface Branding {
  appName: string;
  organisationName: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  timezone: string;
}

export const branding: Branding = {
  // Read one at a time, never as `const env = import.meta.env`. Capturing the
  // whole object makes Vite inline every VITE_ variable the build machine
  // happens to have - a production bundle carried a developer's values, plus a
  // DEV flag that was true in a production build.
  appName: import.meta.env.VITE_APP_NAME || 'Forms',
  organisationName: import.meta.env.VITE_ORG_NAME || 'Taco Bell Costa Rica',
  logoUrl: import.meta.env.VITE_BRAND_LOGO_URL || '/brand/logo.svg',
  faviconUrl: import.meta.env.VITE_BRAND_FAVICON_URL || '/brand/favicon.svg',
  primaryColor: import.meta.env.VITE_BRAND_PRIMARY || '#5d2994',
  secondaryColor: import.meta.env.VITE_BRAND_SECONDARY || '#9346d7',
  accentColor: import.meta.env.VITE_BRAND_ACCENT || '#ffc300',
  timezone: import.meta.env.VITE_DEFAULT_TIMEZONE || 'America/Costa_Rica',
};

/**
 * The API is always same-origin, so there is no base URL to configure.
 *
 * It used to be `VITE_API_URL`, and that was a trap: Vite bakes the value in at
 * build time from whatever .env the machine doing the build happens to have. A
 * production bundle built on a developer's machine shipped with
 * `http://localhost:3000` in it and could not reach its own API - the sign-in
 * page rendered with no buttons, because the call that tells it which providers
 * exist never arrived.
 *
 * Nothing needs it. The dev server proxies /api (see vite.config.ts), which was
 * always the point: one origin in development and in production, so the session
 * cookie behaves the same in both. To develop against a different API, set
 * `API_PROXY_TARGET` for the dev server instead of rewriting the bundle.
 */
